export default __webpack_public_path__ + "static/media/Q12020.0f26fc7a.PDF";